import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomButton from "../ui/CustomButton";

/**
 * Inline contextual nudge — filter apply, deal detail, etc.
 */
const ReminderContextNudge = ({
  title,
  description,
  ctaLabel = "Get Telegram alerts",
  onSetUp,
  onDismiss,
  compact = false,
}) => (
  <Box
    sx={{
      display: "flex",
      alignItems: compact ? "center" : "flex-start",
      gap: 1,
      p: compact ? 1.5 : 2,
      borderRadius: "14px",
      bgcolor: "rgba(201, 226, 255, 0.45)",
      border: "1px solid rgba(0, 136, 204, 0.12)",
    }}
  >
    <Box sx={{ minWidth: 0, flex: 1 }}>
      <Typography
        sx={{
          fontSize: compact ? "14px" : "15px",
          fontWeight: 600,
          color: "#000",
          lineHeight: 1.3,
        }}
      >
        {title}
      </Typography>
      {description ? (
        <Typography
          sx={{
            fontSize: "13px",
            color: "#555",
            mt: 0.35,
            lineHeight: 1.45,
          }}
        >
          {description}
        </Typography>
      ) : null}
    </Box>
    <CustomButton
      variant="primary"
      onClick={onSetUp}
      preventSpam={false}
      sx={{
        flexShrink: 0,
        px: 1.5,
        py: 0.4,
        minHeight: 32,
        fontSize: "12px",
        lineHeight: 1.2,
      }}
    >
      {ctaLabel}
    </CustomButton>
    {onDismiss ? (
      <IconButton
        size="small"
        onClick={onDismiss}
        aria-label="Dismiss"
        sx={{ flexShrink: 0, p: 0.35, color: "#888" }}
      >
        <CloseIcon sx={{ fontSize: 18 }} />
      </IconButton>
    ) : null}
  </Box>
);

export default ReminderContextNudge;
